import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

const CustomSwitch = withStyles({
  switchBase: {
    '&$checked': {
      color: '#4a8bcc',
      '&:hover': {
        backgroundColor: 'rgba(74, 139, 204, 0.1)',
      },
    },
    '&$checked + $track': {
      backgroundColor: '#84a5c7',
    },
  },
  checked: {},
  track: {},
})(Switch);

export default CustomSwitch;
